module.exports = __webpack_public_path__ + "img/user-head.44ea92e9.png";